//Introduced this function to make potential future changes easier to implement - it would be easier to spot all the places in code we differentiate between rpdx versions.
//Since it was not used from the beginning, there might be places in code where we differentiate differently, but I tried to find all the places where we differentiate between rpdx versions.
export const isRpdx7 = (rpdxVersion?: string): rpdxVersion is string => {
  return rpdxVersion?.startsWith('7.') ?? false;
};
